import axios from '../../plugins/axios';

export const getMonthlyStates = ({commit}, { year, month}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/monthly-states/year/${year}/month/${month}`, config)
    .then((response) => {
    const businessesMonthlyStates = response.data
    commit('SET_BUSINESSES_MONTHLY_STATES', { businessesMonthlyStates, skipTimestamp: true })
      return response 
    })
    .catch((error) => error.response );
}

export const updateBusinessServiceStates = ({commit, state}, { data, year, month }) => {
  // Incrementar contador de actualizaciones pendientes
  commit('INCREMENT_PENDING_UPDATES');
  
  // Actualización optimista: actualizar el estado localmente antes de enviar al servidor
  const optimisticUpdate = JSON.parse(JSON.stringify(state.businessesMonthlyStates)); // Deep clone
  
  // Buscar y actualizar el estado específico en la copia local
  const business = optimisticUpdate.find(b => b.id === data.businessId);
  if (business && business.services) {
    const service = business.services.find(s => s.id === data.serviceId);
    if (service && service.state) {
      service.state.id = data.stateId;
      if (data.optionalValue !== null && data.optionalValue !== undefined) {
        service.state.value = data.optionalValue;
      }
    }
  }
  
  // Aplicar la actualización optimista inmediatamente (esto actualiza el timestamp)
  commit('SET_BUSINESSES_MONTHLY_STATES', { businessesMonthlyStates: optimisticUpdate });
  
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  
  // Enviar la actualización al servidor
  return axios.put(`/api/monthly-states/year/${year}/month/${month}`, data, config)
    .then((response) => {
      // Decrementar contador de actualizaciones pendientes
      commit('DECREMENT_PENDING_UPDATES');
      return response 
    })
    .catch((error) => {
      // En caso de error, recargar los estados desde el servidor
      console.error('❌ Error actualizando estado, recargando desde servidor...');
      commit('DECREMENT_PENDING_UPDATES');
      
      axios.get(`/api/monthly-states/year/${year}/month/${month}`, config)
        .then((response) => {
          const businessesMonthlyStates = response.data;
          commit('SET_BUSINESSES_MONTHLY_STATES', { businessesMonthlyStates, skipTimestamp: true });
        });
      return error.response;
    });
}


